import type { SelectMenuOption } from '../components/ui/SelectMenu';

type BudgetRange = SelectMenuOption & { min?: number; max?: number };

export const budgetRanges: BudgetRange[] = [
  { value: '', label: 'Any budget', description: 'Show every annual price' },
  { value: 'under-2500', label: 'Under GHS 2,500', description: 'Lower-cost private options', max: 250000 },
  { value: '2500-3500', label: 'GHS 2,500 – 3,500', description: 'Popular student range', min: 250000, max: 350000 },
  { value: '3500-5000', label: 'GHS 3,500 – 5,000', description: 'More room and facility choices', min: 350000, max: 500000 },
  { value: '5000-7500', label: 'GHS 5,000 – 7,500', description: 'Premium hostel options', min: 500000, max: 750000 },
  { value: '7500-plus', label: 'GHS 7,500+', description: 'No upper limit', min: 750000 },
];

export const occupancyOptions: SelectMenuOption[] = [
  { value: '', label: 'Any room', description: 'All occupancy types' },
  { value: '1', label: 'Private room', description: 'One occupant' },
  { value: '2', label: 'Two occupants', description: 'Shared by two students' },
  { value: '3', label: 'Three occupants', description: 'Shared by three students' },
  { value: '4', label: 'Four occupants', description: 'Shared by four students' },
];

export function applyBudgetRange(params: URLSearchParams, value: string) {
  params.delete('minPrice');
  params.delete('maxPrice');
  const range = budgetRanges.find(option => option.value === value);
  if (range?.min) params.set('minPrice', String(range.min));
  if (range?.max) params.set('maxPrice', String(range.max));
}

export function budgetRangeFromParams(params: URLSearchParams) {
  const min = Number(params.get('minPrice') || 0) || undefined;
  const max = Number(params.get('maxPrice') || 0) || undefined;
  return budgetRanges.find(range => range.min === min && range.max === max)?.value ?? '';
}

export function budgetRangeLabel(value: string) {
  return budgetRanges.find(range => range.value === value)?.label ?? 'Any budget';
}
